module.exports = __webpack_public_path__ + "img/maj4.67d1e16f.jpg";